<template>
  <div class="forgetPwd">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <form>
          <div class="input-box">
            <div class="item">
              <span>交易账号</span>
              <p>{{ user.loginname }}</p>
            </div>
          </div>
          <div class="input-box">
            <div class="item">
              <span>旧密码</span>
              <input v-model="login.oldPwd" class="input-item" :type="[showOldPwd?'text':'password']" minlength="5" maxlength="16" placeholder="请输入密码">
            </div>
            <img v-if="showOldPwd" class="icon" src="@/assets/images/login/open-code.png" alt="" @click="togglePwd(1)">
            <img v-else class="icon" src="@/assets/images/login/close-code.png" alt="" @click="togglePwd(1)">
          </div>
          <div class="input-box">
            <div class="item">
              <span>新密码</span>
              <input v-model="login.newPwd" class="input-item" :type="[showNewPwd?'text':'password']" minlength="8" maxlength="16" placeholder="请输入密码" @blur="passwordBlur">
            </div>
            <img v-if="showNewPwd" class="icon" src="@/assets/images/login/open-code.png" alt="" @click="togglePwd(2)">
            <img v-else class="icon" src="@/assets/images/login/close-code.png" alt="" @click="togglePwd(2)">
          </div>
        </form>
        <div class="forgetPwd-tips">
          新密码必须满足以下要求：
          <ul>
            <li>1. 密码长度需要8至16位字符。</li>
            <li>2. 密码必须包含四种字符类型：小写字母、大写字母、数字和特殊字符（只限-_.~四种字符）。</li>
          </ul>
        </div>
        <div class="btnItem">
          <p class="errMessage">{{ errMessage }}</p>
          <button type="submit" class="submit btn-inner" :disabled="!isNewPwdValid" @click="forgetPwd()">确认</button>
          <p class="chat">手机号码不能用了，请联系<a @click="openLive800">在线客服</a></p>
        </div>
        <p class="reminder">温馨提示：若真实账号与模拟账号有绑定关系，将统一修改真实与模拟账号的密码；修改密码同时适用于账号下所有交易平台。</p>
      </div>
    </div>
    <!--修改密码成功-->
    <div v-if="sucPop" class="popFixed">
      <div class="masking" />
      <div class="tcCon">
        <div class="item">
          <p>密码已设置成功，3s后自动返回登录</p>
        </div>
        <div class="btnCon only">
          <span @click="goLogin">去登录({{ count }}s)</span>
        </div>
      </div>
    </div>

    <AddMT5
      :execute="executeAddMT5"
      @onSuccess="beforeLogout"
    />
  </div>
</template>

<script>
require('@/assets/css/forgetPwd.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import AddMT5 from '@/view/addMT5/AddMT5.vue'
export default {
  name: 'ModifyPwd',
  components: { Header, AddMT5 },
  computed: {
    ...mapState(['user']),
    pwdParam: {
      get() {
        return {
          customerNumber: this.user.loginname,
          oldPassword: this.login.oldPwd,
          newPassword: this.login.newPwd
        }
      }
    },
    isNewPwdValid() {
      const Regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_.~])[A-Za-z\d-_.~]{8,16}$/
      return Regex.test(this.login.newPwd)
    }
  },
  data() {
    return {
      title: '密码管理',
      showOldPwd: false,
      showNewPwd: false,
      login: {
        oldPwd: '',
        newPwd: ''
      },
      errMessage: '',
      sucPop: false,
      count: '',
      timer: '',
      rightContent: 'isNo',
      isAddMT5: this.$route.query.addMT5 ? !!JSON.parse(this.$route.query.addMT5) : false,
      executeAddMT5: false
    }
  },
  mounted() {
    this.$bus.$emit('loading', true)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  activated() {
    this.$bus.$emit('loading', true)
  },
  methods: {
    passwordBlur(e) {
      const Regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_.~{};':"\\|,.<>\/?])[A-Za-z\d-_.~{};':"\\|,.<>\/?]{8,16}$/
      if (!Regex.test(this.login.newPwd)) {
        this.errMessage = '请输入符合规则密码'
      } else {
        this.errMessage = '' // 清空错误信息
      }
    },
    openLive800() {
      var url = `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (400 / 2)
      window.open(url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' + top + ', left=' + left)
    },
    togglePwd(type) {
      if (type == 1) this.showOldPwd = !this.showOldPwd
      else this.showNewPwd = !this.showNewPwd
    },
    forgetPwd() {
      const Regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_.~{};':"\\|,.<>\/?])[A-Za-z\d-_.~{};':"\\|,.<>\/?]{8,16}$/;
      const readyData = this.$qs.stringify(this.pwdParam)
      if (this.login.oldPwd.length >= 5 && this.login.newPwd.length >= 8) {
        // console.log(this.login.newPwd)
        if (!Regex.test(this.login.newPwd)) this.errMessage = '请输入8-16位字母数字特殊字符组合密码'
        else {
          api.modifyPassword(readyData).then(res => {
            if (res.data.code == 200) {
              this.errMessage = ''
              if (this.isAddMT5) {
                this.executeAddMT5 = true
              } else {
                this.beforeLogout()
              }
            } else this.errMessage = res.data.code_desc
          })
        }
        // console.log("errMessage", this.errMessage)
      } else {
        this.errMessage = '请输入符合规则密码'
      }
    },
    goLogin() {
      this.$bus.$emit('loading', false)
      localStorage.clear()
      this.$store.dispatch('setUser', {})
      this.$store.dispatch('setTokenCookie', {})
      if (this.$route.query.pageType) this.$store.dispatch('setPageType', this.$route.query.pageType)
      this.sucPop = false
      this.$router.go(0)
    },
    countDown() {
      const time = 3
      if (this.sucPop) {
        this.count = time
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= time) {
            this.count--
          } else {
            this.goLogin()
          }
        }, 1000)
      } else clearInterval(this.timer)
    },
    beforeLogout() {
      this.sucPop = true
      this.countDown()
    }
  }
}
</script>
